import { Observable, of } from 'rxjs';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { inject } from '@angular/core';
import { z } from 'zod/v4';
import { AppConfigService } from '../../app-config.service';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IBAN_ALLOWED_SCHEMA, IbanString, IIbanAllowed } from '@web/dtos';

export class IbanValidationGateway {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<string, boolean> =
    new RestCallBuilder<string, boolean>(false);
  private readonly restCallBuilderBlacklist: RestCallBuilder<
    string,
    IIbanAllowed
  > = new RestCallBuilder<string, IIbanAllowed>({ isIbanAllowed: false });

  validateIbanCountry(countryCode: string): Observable<IApiResponse<boolean>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.addressValidationUrl}/is-sepa?countryCode=${countryCode}`
      )
      .validate(API_RESPONSE_SCHEMA(z.boolean()), 'Iban.Sepa')
      .handleMessages()
      .build();
  }

  validateIbanAgainstBlacklist(
    iban: IbanString
  ): Observable<IApiResponse<IIbanAllowed>> {
    return this.restCallBuilderBlacklist
      .getExternal(
        `${this.configService.get().general.webshopApiUrl}/api/bank-data/is-iban-allowed`,
        { iban }
      )
      .validate(API_RESPONSE_SCHEMA(IBAN_ALLOWED_SCHEMA), 'Iban.Blacklist')
      .handleMessages()
      .build();
  }
}
